import { Permission } from "./permissions";
import { Role } from "./roles";

const ALL_PERMISSIONS = Object.values(Permission);

export const ROLE_PERMISSIONS = {
  [Role.ADMIN]: new Set(ALL_PERMISSIONS),
  [Role.PMO]: new Set([
    Permission.PROJECT_VIEW,
    Permission.PROJECT_CREATE,
    Permission.PROJECT_EDIT,
    Permission.REVIEW_VIEW,
    Permission.REVIEW_CREATE,
    Permission.REVIEW_EDIT,
    Permission.RISK_UPLOAD,
    Permission.SETTINGS_EDIT,
    Permission.USER_APPROVAL,
  ]),
  [Role.ACCOUNT_MANAGER]: new Set([
    Permission.PROJECT_VIEW,
    Permission.PROJECT_CREATE,
    Permission.PROJECT_EDIT,
    Permission.REVIEW_VIEW,
    Permission.REVIEW_CREATE,
    Permission.REVIEW_EDIT,
    Permission.RISK_UPLOAD,
    Permission.SETTINGS_EDIT,
    Permission.USER_APPROVAL,
  ]),
  [Role.DELIVERY_MANAGER]: new Set([
    Permission.PROJECT_VIEW,
    Permission.PROJECT_EDIT_ASSIGNED,
    Permission.REVIEW_VIEW,
    Permission.REVIEW_EDIT_ASSIGNED,
    Permission.RISK_UPLOAD,
  ]),
  [Role.PROJECT_MANAGER]: new Set([
    Permission.PROJECT_VIEW,
    Permission.PROJECT_CREATE,
    Permission.PROJECT_EDIT_ASSIGNED,
    Permission.REVIEW_VIEW,
    Permission.REVIEW_CREATE,
    Permission.REVIEW_EDIT_ASSIGNED,
    Permission.RISK_UPLOAD,
  ]),
  [Role.CLIENT_PARTNER]: new Set([
    Permission.PROJECT_VIEW,
    Permission.REVIEW_VIEW,
  ]),
};
